import PersonIcon from '@mui/icons-material/Person';
import { useState } from 'react';

import { LayoutModule } from '../../../../layout/modules';
import { Box } from '@mui/material';

import ActionButtonGroup from '../../../../components/general/buttons/actionButtonGroup';
import { InitialCausalityInfo } from './data';
import { InitialCausalityRegisterHistory } from './registerHistory';
import { InitialCausalityHistorical } from '../historical';
import { useInitialCausalityDetail } from './hook';
import {
    INITIAL_CAUSALITY_EDIT,
    INITIAL_CAUSALITY_NEW,
    INITIAL_CAUSALITY,
} from '../../../../../routes/paths';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../redux/store';
import { isOnlyViewProfile } from '../../../../../shared/types/profiles';

export const InitialCausalityDetail = () => {
    const { logUser } = useSelector((state: RootState) => state.general);
    const { type } = logUser || {};
    const [showHistorical, setShowHistorical] = useState(false);
    const { initialCausality, loading, initialCausalityHistorical } =
        useInitialCausalityDetail(showHistorical);

    const toggleHistorical = () => {
        setShowHistorical(!showHistorical);
    };

    const showActionButtons =
        initialCausality && initialCausality?.id ? true : false;

    return (
        <>
            <LayoutModule
                title="Detalle Causalidad Inicial"
                withAccordion={false}
                additionalButtons={
                    <ActionButtonGroup
                        id={initialCausality?.id || ''}
                        buttonCreate={{
                            show: showActionButtons && !isOnlyViewProfile(type),
                            route: INITIAL_CAUSALITY_NEW,
                        }}
                        buttonSearch={{
                            show: true,
                            route: INITIAL_CAUSALITY,
                        }}
                        buttonUpdate={{
                            show: !isOnlyViewProfile(type),
                            route: INITIAL_CAUSALITY_EDIT,
                        }}
                        buttonView={{
                            show: false,
                        }}
                        buttonLog={{
                            show: showActionButtons,
                        }}
                        onHistoricalShow={toggleHistorical}
                    />
                }
            >
                {showHistorical && (
                    <Box sx={{ marginTop: 2 }}>
                        <InitialCausalityHistorical
                            historical={initialCausalityHistorical ?? []}
                            showHistorical={true}
                        />
                    </Box>
                )}
                <LayoutModule
                    title="Interno"
                    showTitle={false}
                    titleChildren="Información general"
                    icon={<PersonIcon sx={{ color: 'primary.main' }} />}
                >
                    <InitialCausalityInfo
                        initialCausality={initialCausality}
                        loading={loading}
                    />
                </LayoutModule>
            </LayoutModule>
            <InitialCausalityRegisterHistory
                initialCausality={initialCausality}
            />
        </>
    );
};
